<script>
import { mapActions, mapState } from 'vuex'
import UIPopoverItem from './popover-item.vue'

export default {
  name: 'ui-popover',
  components: {
    'ui-popover-item': UIPopoverItem,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState('events', {
      events: state => state.popover.events,
      isOpened: state => state.popover.isOpened,
      style: state => state.popover.style,
    }),
  },
  methods: {
    ...mapActions('events', {
      events_setPopoverClosed: 'setPopoverClosed',
    }),
    handleClickOutside(event) {
      if (
        event.target.closest('.fc-more-link') ||
        event.target.closest('.t-events-calendar-block') ||
        event.target.closest('.fc-event') ||
        event.target.closest('.js-modal')
      )
        return

      this.events_setPopoverClosed()
    },
  },
}
</script>

<template>
  <div v-if="isOpened" :style="style" class="t-events-calendar-block" v-click-outside="handleClickOutside">
    <ui-popover-item v-for="event in events" :event="event" :key="event.id" :form="form" />
  </div>
</template>



// WEBPACK FOOTER //
// src/templates/pages/events/components/popover/popover.vue